import React, { Component } from 'react'
import { 
	postPromise,
	getParams,
	setCookie,	
	isEmptyObject,
	addClassToHtmlElement,
	removeClassFromHtmlElement, 
	createUrl,
	ajaxPost,
	getCookie
} from '../../common/utils.js'
import { PurchaseHeader, ColorSelector, TipPop, ImageCode } from './components'
import { ONECLOUD_API_HOST } from '../../common/consts'
import t from '../../i18n/purchase'

export default class TqcodePurchase extends Component {
	constructor(props){
		super(props)
		const channelCfg = {			
			price: {
				'1': 449,
				'2': 599
			}
		}
		const channel = +getParams('channel') || 1
		this.params = {
			channel,
			price: channelCfg.price[channel]
		}

		this.state = {
			color: 'black',
			popShow: false,
			popMsg: '',
			popJump: '',
			popBtn: t('ok'),
			colorConfig: [
				{color:'black', text:t('color_black'),has:0},
				{color:'blue', text:t('color_blue'),has:0},
				{color:'orange', text:t('color_orange'),has:0}
			]
		}

		this.popClose = ()=> {
			this.setState({popShow: false})
		}
		this.switchColor = (color)=>{
			this.setState({ color })
		}

		this.vcodeChangeOnParent = (value)=>{
			this.setState({
				valueOfVcode: value,
				vcodeIsEmpty: false,
				vcodeIsError: false
			})
		}
		this.vcodeClose = ()=>{
			this.setState({
				ifShowVcode: false,
				valueOfVcode:null,
				vcodeIsEmpty: false,
				vcodeIsError: false
			});
			removeClassFromHtmlElement()
		}
		this.vcodeOpen = ()=>{
			this.setState({
				ifShowVcode: true
			})
			addClassToHtmlElement()
		}

		this.submit = this.submit.bind(this)
		this.showPopHandler = this.showPopHandler.bind(this)
	}

	componentDidMount() {
		this.params.channel === 1 ? this.queryQualify() : this.getColorList()
	}

	queryQualify() {
		const phone = getCookie('phone')				
		if (!phone) return this.jumpToLogin()

		const jumpUrl = 'html/fjupspeed'
        ajaxPost(
            `${ONECLOUD_API_HOST}/tqcode/query`, 
            { phone: phone, channel: 1 },  // channel=1 福建电信
            (res) => {                                               				                             
                switch(+res.iRet) {
					case 0:					
						this.getColorList()	
                        return                    
					case -501:						
                        this.jumpToLogin()
                        return
                    default:
						this.jumpToUrl(jumpUrl)
                }
            },
            () => {
                this.jumpToUrl(jumpUrl)
            }
        )              
	}	
		
	getColorList() {
		ajaxPost(
            `${ONECLOUD_API_HOST}/tqcode/colorlist`, 
            { channel: this.params.channel },  // channel=1福建电信 2迅雷会员
            (res) => {                				                                                         
                switch(+res.iRet) {
                    case 0:
                        this.setColorConfig(res.data)
                        return                                            
                    case -501:
                        this.jumpToLogin()
                        return
                    default:
                        this.showPopHandler(res.sMsg)
                }
            },
            () => {
                this.popTip('网络繁忙，请稍后再试（s）')
            }
        ) 
	}

	setColorConfig(data) {		
		let colorConfig = this.state.colorConfig		
		let curColor, hasColor, countHas = 0		
		for (let item of colorConfig) {					
			curColor = item.color
			item.has = data[`has_${curColor}`]
			if (+data[`has_${curColor}`]) {
				countHas++
				hasColor = curColor
			}			
		}	
		this.setState({
			colorConfig,
			color: countHas === 1 ? hasColor : 'black'
		})
	}

	jumpToLogin() {
        location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(location.href)}`
	}
	
	jumpToUrl(url) {
        location.href = createUrl(url)
    }

	showPopHandler(msg,url,btn){
		this.setState({
			popShow: true,
			popMsg: msg,
			popJump: url||'',
			popBtn: btn||t('ok')
		})
	}

	commonErrorHandler(resCode, callback, res){
		let statusList = {
			'30004' : t('rtncode_30004'),
			'30006' : t('rtncode_30006'),
			'30008' : t('rtncode_30008'),
			'30009' : t('rtncode_30009'),
			'40000' : t('rtncode_40000'),
			'30003' : t('rtncode_30003'),
			'30106' : t('rtntqcode_used'),		
			'30203': '您已参与过特权码购买活动',		
			'30201': '您的特权码已过期',
			'-2' : t('rtncode__2'),
			'-2004': t('rtncode__2004'),
			'-2000': t('rtncode__2000'),
			'-1003': t('rtntqcode_used'),
			'-5': t('rtncode__5'),

			"41006": t('rtncode_41006'),
			"41007": t('rtncode_41007_2'),
			"41009": t('rtncode_41009'),
			"41012": t('rtncode_41012'),
			"41013": t('rtncode_41013'),
			"41014": t('rtncode_41014'),
			'41016': t('rtncode_41016'),
			'41018': t('rtncode_41018'),
			"41022": t('rtncode_41022')
		}
		
		let specialList = {
			'1': {
				'30106': '您已使用福建电信专享版特权码',
				'-1003': '您已使用福建电信专享版特权码',
				'30203': '您已参与过福建电信专享版特权码购买活动',
				'30201': '您的福建电信专享版特权码已过期'
			}
		}

		if (this.params.channel === 1) {
			Object.assign(statusList, specialList[1])
		}
	
		let sellOutList = {
			'30005' : t('rtncode_30005'),
			'30016' : t('rtncode_30016'),
			'30025' : t('rtncode_30025'),
			'30026' : t('rtncode_30026')
		}

		if(resCode == -501){
			let url = window.location.href
			location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(url)}`
		} else if(resCode == 30203) {
			this.showPopHandler(statusList[resCode], createUrl('html/usercenter'), t('check_order'))
		}else if(sellOutList[resCode]){
			if(resCode==30005){
				this.showPopHandler(sellOutList[resCode])
			}else {
				this.showPopHandler(sellOutList[resCode],'',t('tips_continue'))
				this.getColorList()
			}
		}else if(statusList[resCode]) {
			this.showPopHandler(statusList[resCode])
		} else if (+resCode !== 0){
			this.showPopHandler(res.sMsg);
		}
		if (callback&&typeof callback=="function"){
			callback(resCode,res)
		}
	}

	responeHandler({res, success}){
		const resCode = res.iRet;
		this.commonErrorHandler(resCode, null, res)

		if(resCode==0) {
			if(res.data){
				success(res.data);
			}else {
				success()
			}
		}
	}
	

	gotoLoginPage(){
		const url = window.location.href
		location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(url)}`
	}

	submit(e){
		e.preventDefault()	
		let postData = {			
			channel: this.params.channel,
			[`${this.state.color}_num`]: 1
		}		

		let doneCb = res=>{
			let success = (data)=>{
				let jumpUrl = createUrl('html/order', {type:'tqcode', orderid:data.order_id})
				window.setTimeout(()=>{
					window.location.href = jumpUrl
				},0)
			}
			this.responeHandler({res, success})
		}
		postPromise(ONECLOUD_API_HOST+ '/tqcode/commit',postData).done(doneCb)
	}

	render(){
		const { color, colorConfig } = this.state
		const params = this.params		
		let popCont =  this.state.popShow ? <TipPop msg={this.state.popMsg} jump={this.state.popJump} btnTxt={this.state.popBtn} onClose={this.popClose}/> : null

		return (
			<div className="oc-buy-box">
				{popCont}

			    <PurchaseHeader hideTxt={true} />
			    <div className="oc-buy-main">
			        <div className="oc-u-tit">
			            <h2>使用特权码购买</h2>
			        </div>			        
			        <ColorSelector colorConfig={colorConfig} currColor={color} onChange={this.switchColor} showZeroColor={false}/>

			        <div className="oc-bot-sum">
			            <a href="javascript:;" className="btn-oc" onClick={this.submit}>{t('buy_now')}</a>
			            <h3>合计：<strong>{params.price}</strong>元</h3>
			            <p>{t('fcode_tips')}</p>
			        </div>
			    </div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/TqcodePurchaseXLVIP.js